// DirectScrollButton.js
import React, { useState, useEffect } from 'react';

const DirectScrollButton = () => {
  const [animationStep, setAnimationStep] = useState(0);
  const [isFixed, setIsFixed] = useState(true);
  
  useEffect(() => {
    // Cycle through animation steps (0-2)
    const interval = setInterval(() => {
      setAnimationStep(prev => (prev + 1) % 3);
    }, 800);
    
    // Handle scroll events to update fixed state
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsFixed(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => {
      clearInterval(interval);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const handleClick = () => {
    // Direct scroll approach: scroll to viewport height
    const viewportHeight = window.innerHeight;
    window.scrollTo({
      top: viewportHeight,
      behavior: 'smooth'
    });
    
    // Set timeout to give animation time to start before removing fixed state
    setTimeout(() => {
      setIsFixed(false);
    }, 100);
  };
  
  return (
    <button 
      onClick={handleClick}
      className={`
        bg-white bg-opacity-70 hover:bg-opacity-100 rounded-full p-1.5 shadow-md
        transition-all duration-300 ease-in-out cursor-pointer
        ml-6 mb-6 z-50
        ${isFixed ? 'fixed bottom-0 left-0' : 'absolute bottom-0 left-0 opacity-0 pointer-events-none'}
      `}
      aria-label="Scroll to next section"
      style={{ width: '36px', height: '36px' }}
    >
      <div className="flex flex-col items-center justify-center h-full">
        {/* Animated dots with fading effect */}
        <div className="space-y-1.5 flex flex-col items-center">
          <div 
            className={`w-1 h-1 bg-black rounded-full transition-opacity duration-500 
              ${animationStep === 0 ? 'opacity-100' : 'opacity-40'}`}
          />
          <div 
            className={`w-1 h-1 bg-black rounded-full transition-opacity duration-500 
              ${animationStep === 1 ? 'opacity-100' : 'opacity-40'}`}
          />
          <div 
            className={`w-1 h-1 bg-black rounded-full transition-opacity duration-500 
              ${animationStep === 2 ? 'opacity-100' : 'opacity-40'}`}
          />
        </div>
      </div>
    </button>
  );
};

export default DirectScrollButton;